import * as React from "react";
import { useRef, useState, useEffect, useCallback } from "react";
import debounce from "lodash/debounce";
import Select from "components/common/Select";
import { Spinner } from "components/common";
const DEFAULT_PAGINATION = { page: 1, perPage: 50, query: "" };
const PaginatedSelect = ({ onLoadOptions, ...rest }) => {
  const selectRef = useRef();
  const [paginatedOptions, setPaginatedOptions] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const loadOptions = useCallback(
    (pagination, processResponse = (res, _cur) => res) => {
      setIsLoading(true);
      return onLoadOptions(pagination).then((res) => {
        setPaginatedOptions((cur) => processResponse(res, cur));
        setIsLoading(false);
      });
    },
    [onLoadOptions]
  );
  const handleSearch = debounce((newValue, actionMeta) => {
    if (actionMeta.action === "input-change") {
      return loadOptions({ ...DEFAULT_PAGINATION, query: newValue });
    }
    if (actionMeta.action === "menu-close") {
      return loadOptions(DEFAULT_PAGINATION);
    }
    return Promise.resolve();
  }, 400);
  const handleLoadMore = debounce(() => {
    const { pagination, total, list } = paginatedOptions;
    const extendList = (res, cur) => ({
      ...res,
      list: [...cur.list, ...res.list]
    });
    if (isLoading) {
      return;
    }
    if (total > list.length) {
      loadOptions({ ...pagination, page: pagination.page + 1, query: "" }, extendList);
    }
  }, 400);
  useEffect(() => {
    if (!paginatedOptions) {
      onLoadOptions(DEFAULT_PAGINATION).then(setPaginatedOptions);
    }
  }, []);
  if (!paginatedOptions) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading options..." });
  }
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      ...rest,
      ref: selectRef,
      options: paginatedOptions.list,
      onInputChange: handleSearch,
      loadOptions: handleLoadMore,
      async: true,
      total: paginatedOptions.total
    }
  );
};
export default PaginatedSelect;
